import { Fragment } from 'react';

import {
  AppDownloadModal,
  AppLoginModal,
  BrowserAutoPlayModal,
  ChapterQuizModal,
  ConcurrentSessionModal,
  EpisodeEvaluationModal,
  EpisodeFeedbackModal,
  KeepGoingPromoModal,
  ListenRejectedModal,
  MemberArchiveModal,
  NewTeamModal,
  OnboardingModal,
  ProductFeedbackModal,
  RedeemModal,
  ShareEpisodeModal,
  ShareWithAFriendModal,
  SignupModal,
  TrackerAddEditModal,
  TrackerDeleteModal,
  UpgradeTeamModal,
} from './components';

export const AppModals = () => {
  return (
    <Fragment>
      <OnboardingModal />
      <ListenRejectedModal />
      <BrowserAutoPlayModal />
      <ConcurrentSessionModal />
      <RedeemModal />
      <ChapterQuizModal />
      <TrackerAddEditModal />
      <TrackerDeleteModal />
      <SignupModal />
      <EpisodeEvaluationModal />
      <EpisodeFeedbackModal />
      <ProductFeedbackModal />
      <AppDownloadModal />
      <AppLoginModal />
      <MemberArchiveModal />
      <NewTeamModal />
      <UpgradeTeamModal />
      <ShareWithAFriendModal />
      <ShareEpisodeModal />
      <KeepGoingPromoModal />
    </Fragment>
  );
};
